import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, ReactNode, useContext } from "react";
import { useSolana } from "../../hooks/solana/useSolana";
import { SolanaConnector } from "../types/solana";
import { ConnectWalletResult, SolanaWallet } from "../types/wallet";

export interface ISolanaContextData {
  connectSolana: UseMutationResult<
    ConnectWalletResult<ChainType.SOLANA>,
    unknown,
    {
      wallet: SolanaWallet;
    },
    unknown
  >;
  disconnectSolana: () => Promise<void>;
  autoConnectSolana: () => Promise<void>;
  signer: SolanaConnector | undefined;
  wallets: SolanaWallet[];
}

export const SolanaContext = createContext<ISolanaContextData | undefined>(
  undefined
);

export const SolanaProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const solanaHook = useSolana();

  return (
    <SolanaContext.Provider value={solanaHook}>
      {children}
    </SolanaContext.Provider>
  );
};

export const useSolanaContext = (): ISolanaContextData => {
  const context = useContext(SolanaContext);
  if (!context) {
    throw new Error("useSolanaContext must be used within a SolanaProvider");
  }
  return context;
};
